import { render, staticRenderFns } from "./PressList.vue?vue&type=template&id=ce1f97ea&scoped=true&"
import script from "./PressList.vue?vue&type=script&lang=js&"
export * from "./PressList.vue?vue&type=script&lang=js&"
import style0 from "./PressList.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./PressList.vue?vue&type=style&index=1&id=ce1f97ea&lang=scss&scoped=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "ce1f97ea",
  null
  
)

export default component.exports